import React, { useState } from "react";
import { db, auth } from "../firebase";
import firebase from "firebase";

function Form({ scroll }) {
  const [msg, setMsg] = useState("");

  async function sendMessage(e) {
    e.preventDefault();
    const { uid, photoURL } = auth.currentUser;

    await db.collection("messages").add({
      text: msg,
      photoURL,
      uid,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
    setMsg("");
    scroll.current.scrollIntoView({ behavior: "smooth" });
  }
  return (
    <form onSubmit={sendMessage}>
      <div className="row align-center sendMsg">
        <div className="col-8 col-sm-10 pe-0">
          <input
            type="text"
            className="form-control py-2 shadow-none border-none"
            placeholder="Message..."
            value={msg}
            onChange={(e) => setMsg(e.target.value)}
            required
          />
        </div>
        <div className="col-4 col-sm-2 ps-0">
          <button
            className="btn btn-success w-100 py-2 shadow-none border-none"
            type="submit"
          >
            Send
          </button>
        </div>
      </div>
    </form>
  );
}

export default Form;
